import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPieChartData } from "../../redux/Slices/dashboardSlice";
import {
  PieChart,
  Pie,
  Cell,
  Label,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Loader from "../../components/Common/Loader";
import { normalizeDateForAPI } from "../../utils/Utils";

const CustomLabel = ({ viewBox, totalLeadCount }) => {
  const { cx, cy } = viewBox;
  return (
    <>
      <text x={cx} y={cy - 15} className="piechart-total-label ">
        Total New Leads
      </text>
      <text x={cx} y={cy + 10} className="piechart-total-value ">
        {totalLeadCount}
      </text>
    </>
  );
};

const PieChartt = ({ startDate, endDate }) => {
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const { pieChartData, loading, error } = useSelector(
    (state) => state.dashboard
  );

  const coachId = profileData?.coachId;
  const wonLeadCount = pieChartData?.wonLeadCount || 0;
  const totalLeadCount = pieChartData?.totalLeadCount || 0;
  const unconvertedLeads = Math.max(totalLeadCount - wonLeadCount, 0);

  useEffect(() => {
    if (coachId) {
      dispatch(
        fetchPieChartData({
          coachId,
          startDate: startDate ? normalizeDateForAPI(startDate) : null,
          endDate: endDate ? normalizeDateForAPI(endDate) : null,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, startDate, endDate, coachId]);

  if (loading) return <Loader />;
  if (error) return <p>{error}</p>;

  const formattedConversionRate = pieChartData?.conversionRate
    ? parseFloat(pieChartData.conversionRate).toFixed(2)
    : "0.00";

  const chartData =
    wonLeadCount === 0 && unconvertedLeads === 0
      ? [{ name: "No Data", value: 1, isPlaceholder: true }]
      : [
          { name: "Won Leads", value: wonLeadCount },
          { name: "Unconverted Leads", value: unconvertedLeads },
        ];

  return (
    <div className="piechart-container ">
      <div className="website-hits-header ">
        {/* Title Section */}
        <div className="website-hits-title ">
          <h1>Lead Activity</h1>
        </div>

        {/* Total Hits Section */}
        <div className="website-hits-total">
          <h1>Lead Conversion Rate</h1>
          <p className="total-hits-count">{formattedConversionRate}%</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={165}>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            outerRadius={80}
            innerRadius={60}
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  entry.isPlaceholder
                    ? "#D3D3D3"
                    : index === 0
                    ? "#383D8D"
                    : "#A42066"
                }
              />
            ))}
            <Label
              content={
                <CustomLabel
                  totalLeadCount={pieChartData?.totalLeadCount || 0}
                />
              }
              position="center"
            />
          </Pie>

          <Tooltip
            formatter={(value, name) => [`${value}`, `${name}`]}
            contentClassName="piechart-tooltip"
          />
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="middle"
            wrapperStyle={{
              marginTop: "20px",
              marginRight: "37px",
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartt;
